import { Button, useToast } from '@chakra-ui/react';
import { Form, useFormikContext } from 'formik';
import React from 'react';
import { getFormErrors } from '../../../services/form/getFormErrors';
import { localise, pluralise, templateReplace, } from '../../../services/lang/lang';
import { FormContainer } from '../../modules/Form/FormContainer';
import StandardFormTextArea from '../../modules/Form/StandardFormTextArea';
import StandardFormMediaUpload from '../../modules/Form/StandardFormMediaUpload';
import { useTrackUnsavedChanges } from '../../modules/UnsavedChanges/useTrackUnsavedChanges';
import RemoteSubmissionLocationInput from './RemoteSubmissionLocationInput';
import TagSelect from './TagSelect';
const MAX_FILE_UPLOAD = 10;
const RemoteSubmissionForm = ({ elements, locationTypes, locations, }) => {
    const toast = useToast();
    const { handleSubmit, values, errors, dirty, isSubmitting, setFieldValue, handleChange, } = useFormikContext();
    useTrackUnsavedChanges(dirty);
    return (React.createElement(Form, { "data-testid": "remote_submission_form" },
        React.createElement(FormContainer, null,
            React.createElement(RemoteSubmissionLocationInput, { locationTypes: locationTypes, locations: locations }),
            React.createElement(TagSelect, { models: elements, label: localise('ELEMENTS_AFFECTED'), selectIds: values.elements ?? [], nameField: "name", value: undefined, onChange: (selected) => setFieldValue('elements', selected), error: getFormErrors(errors, 'elements') }),
            React.createElement(StandardFormTextArea, { error: errors.description, value: values.description, label: localise('DESCRIPTION'), onChange: handleChange, name: "description", placeholder: localise('DESCRIBE_WHAT_YOU_SEE') }),
            React.createElement(StandardFormMediaUpload, { files: values.media, label: localise('UPLOAD_MEDIA'), error: getFormErrors(errors, 'media'), maxFiles: MAX_FILE_UPLOAD, accept: ".jpg,.jpeg", onChange: (files) => setFieldValue('media', files), subText: templateReplace(localise('IMAGE_UPLOAD_RESTRICTION'), {
                    fileNum: MAX_FILE_UPLOAD,
                }), onUploadMoreThanMax: () => {
                    toast({
                        title: localise('SOME_FILES_SKIPPED'),
                        description: templateReplace(localise('MAX_UPLOAD_REACHED'), {
                            limit: MAX_FILE_UPLOAD,
                        }),
                        status: 'error',
                        duration: 3000,
                        isClosable: true,
                    });
                }, onDuplicateFilesAdded: (duplicateFiles) => {
                    toast({
                        title: localise('SOME_FILES_SKIPPED'),
                        description: templateReplace(localise('DUPLICATE_FILES_DETECTED'), {
                            duplicates: duplicateFiles,
                            image: pluralise(localise('IMAGE'), duplicateFiles),
                        }),
                        status: 'info',
                        duration: 3000,
                        isClosable: true,
                    });
                } }),
            React.createElement(Button, { isDisabled: !dirty || isSubmitting, isLoading: isSubmitting, onClick: () => handleSubmit(), variant: "primary", width: "100%" }, localise('SUBMIT')))));
};
export default RemoteSubmissionForm;
